<template>
  <div>
    <h1>Страница поста с ID = {{ $route.params.id }}</h1>
  </div>
</template>

<script>
export default {};
</script>

<style scoped></style>
